var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1849,
    height: 1849,
    viewBox: "0 0 1849 1849",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_39)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1251.7,
    cy: 1251.7,
    r: 287.5,
    transform: "rotate(-135 1251.7 1251.7)",
    stroke: "#0F0D2A",
    strokeWidth: 128
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2_39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.466 422.118L292.544 447.04L317.466 471.963L292.544 496.885L267.621 471.963L242.699 496.885L217.777 521.807L192.854 546.73L167.824 571.977L192.854 596.575L167.932 621.497L143.01 596.575L118.087 621.497L217.777 721.187L300.53 803.94L371.212 733.257L337.271 699.316L320.301 716.286L286.36 682.345L354.242 614.463L388.183 648.404L371.212 665.375L405.153 699.316L439.095 665.375L422.124 648.404L456.065 614.463L523.947 682.345L490.006 716.287L473.036 699.316L439.095 733.257L473.036 767.198L490.006 750.228L523.947 784.169L456.065 852.051L422.124 818.11L439.095 801.139L405.153 767.198L334.471 837.881L417.018 920.428L516.707 1020.12L541.63 995.195L516.815 970.381L541.63 945.351L566.228 970.381L591.474 945.351L616.397 920.428L641.319 895.506L666.242 870.584L641.319 845.661L666.242 820.739L691.164 845.661L716.086 820.739L516.845 621.497L317.466 422.118Z",
    fill: "#0F0D2A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950.825,
    y: 1027.19,
    width: 895.704,
    height: 128,
    transform: "rotate(-135 950.825 1027.19)",
    fill: "#0F0D2A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1848.83,
    height: 1848.83,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1680.7,
    height: 933.93,
    fill: "white",
    transform: "translate(1188.44 1848.83) rotate(-135)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 915.704,
    height: 751.93,
    fill: "white",
    transform: "translate(730.232 1261.93) rotate(-135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98b6b5eb20f9df7ef4ba2a1bad3ae05b.svg";
export { ForwardRef as ReactComponent };